import { draftConfirmed } from './draft-events.ts';
export type RecoveryStorage = Pick<Storage, 'length' | 'key' | 'getItem' | 'setItem' | 'removeItem'>;
export type DraftReference = { key: string; snapshot: string };
export function validateDraftReference(value: unknown, prefix: string) {
  if (value === undefined) return;
  const ref = value as DraftReference;
  if (!ref || typeof ref.key !== 'string' || !ref.key.startsWith(prefix) || typeof ref.snapshot !== 'string' || ref.snapshot.length > 2000000) throw new Error('Invalid saved draft reference');
}
export function clearConfirmedDraft(ref: DraftReference | undefined, storage: RecoveryStorage) {
  if (!ref || storage.getItem(ref.key) !== ref.snapshot) return;
  storage.removeItem(ref.key);
  if (storage.getItem(ref.key) !== null) throw new Error('The confirmed browser draft could not be cleared. Retry the saved action.');
  draftConfirmed(ref.key, ref.snapshot);
}
export const browserStorage: RecoveryStorage = {
  get length() { return globalThis.localStorage.length; },
  key: i => globalThis.localStorage.key(i),
  getItem: key => globalThis.localStorage.getItem(key),
  setItem: (key, value) => globalThis.localStorage.setItem(key, value),
  removeItem: key => globalThis.localStorage.removeItem(key),
};
export function recoveryPrefix(kind: string, base: string, account: { userId: string; domain: string; organizationId?: string }) {
  return `whenly-recovery-v1:${JSON.stringify([kind, base, account.userId, account.domain, account.organizationId || ''])}:`;
}
export function storedKeys(storage: RecoveryStorage, prefix: string) {
  return Array.from({ length: storage.length }, (_, i) => storage.key(i))
    .filter((key): key is string => !!key && key.startsWith(prefix)).sort();
}
export async function recoveryLock<T>(name: string, action: () => Promise<T>): Promise<T> {
  if (typeof navigator !== 'undefined' && navigator.locks) return navigator.locks.request(name, action);
  return action();
}
export function commandBody(value: unknown, userId: string): asserts value is { requestId: string; path: string; body: string } {
  if (!value || typeof value !== 'object') throw new Error('Invalid saved action');
  const row = value as Record<string, unknown>;
  if (typeof row.requestId !== 'string' || !/^[A-Za-z0-9_-]{16,100}$/.test(row.requestId)
    || typeof row.path !== 'string' || typeof row.body !== 'string' || row.body.length > 2000000) throw new Error('Invalid saved action');
  const body = JSON.parse(row.body);
  if (!body || Array.isArray(body) || typeof body !== 'object' || body.request_id !== row.requestId || body.expected_user_id !== userId) throw new Error('Invalid saved action');
}
